export default {
  title: "Productos o servicios",
  titleDescription: "Ingresa el monto total de todas las unidades de los medicamentos",
  cosharings: "Participaciones",
  beneficiaryPayment: "Beneficiario",
  sponsorPayment: "Aseguradora",
  invoiceData: "Datos de factura para aseguradora (Opcional)",
  enterData: "Ingresa los siguientes datos",
  copaymentDescription: "*Copago",
  coinsuranceDescription: "*Coaseguro",
  invoice: {
    labels: {
      upload: "Factura (Opcional)",
      uploadRestrictions: "Archivos en formato PDF, PNG o JPEG, peso máximo 20Mb",
      number: "No. de factura",
      amount: "Monto facturado",
      date: "Fecha de factura",
      noFiles: "No hay archivos adjuntos"
    }
  },
  buttons: {
    cosharings: {
      get: "Obtener participaciones",
      update: "Actualizar participaciones"
    },
    uploadFile: "Agregar"
  },
  errors: {
    multipleFileUpload: "Solo se puede cargar un archivo a la vez"
  },
  headers: {
    quantity: "Cantidad",
    productName: "Nombre",
    status: "Estado",
    subtotal: "Precio unitario"
  },
  status:{
    approved: "Aprobado",
    rejected: "Rechazado"
  },
  validations: {
    cosharings: "Debe obtener las participaciones para continuar.",
    invoiceFields: "Ingrese los datos de factura para aseguradora.",
    invoiceFile: "Debe agregar la factura"
  }
}